import Modal from 'react-modal';
import { getPermission, parseToFloat, showMessageError, viewItemProduct } from '../../../../classes/functions';
import { toast } from 'react-toastify';
import api from '../../../../config';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

export default function ModalMakeReturn({ modalMakeReturn, setModalMakeReturn, setItemReturn, customStyles, observation_return, setObservationReturn, view, listReturn, listProducts, setCarrying, redirect, id }) {
  const history = useHistory();

  function submit() {
    let aux = true;
    let list = [];
    
    listReturn.map((element) => {
      if (element.qtde_devolucao && element.qtde_devolucao != '') {
        list.push(element);
      }
    });
    
    list.map((element) => {
      if (parseToFloat(element.qtde_devolucao) > element.quantity_available_return) {
        toast.error('A quantidade de devolução não pode ser maior do que a quantidade separada.');
        aux = false;
      }
    });

    if (observation_return.length === 0) {
      toast.error('Preencha a observação de devolução.');
      aux = false;
    }
    
    if (list.length === 0) {
      toast.error('Ops! Preencha a quantidade de pelo menos 1 para realizar a devolução.');
      aux = false;
    }

    list.map((element) => {
      if(element?.id_armazem){
        element.warehouse_return = element?.id_armazem;
      }

      if(element?.id_warehouse){
        element.warehouse_return = element?.id_warehouse;
      }

      return element;
    });

    if (aux) {
      api.post("/api/return_request/setMakeReturn", { rows: list, observation: observation_return, origem: redirect === '/epis_requests' ? 'E' : 'C', id_request: parseInt(id) })
        .then((response) => {
          toast.success('Registro inserido com sucesso.');
          history.push(redirect);
        }).catch((error) => {
          console.log(error)
          showMessageError(error.response.data);

          setCarrying(false);
        });
    }
  }

  return (
    <Modal
      isOpen={modalMakeReturn}
      onRequestClose={() => setModalMakeReturn(false)}
      style={customStyles}
      contentLabel="Itens para Devolução"
      ariaHideApp={false}
      keepMounted
    >
      <div className="body-modal">
        <h1>Itens para devolução</h1>
        <div className="formDiv">
          <label>Observação de Devolução</label><br />
          <input type="text" placeholder="Observação de Devolução" value={observation_return} onChange={(e) => setObservationReturn(e.target.value)} maxLength="200" disabled={!getPermission("OPERACOES - REQUISICAO DEVOLUCAO - CADASTRO")} />
        </div>
        <div className="formDiv">
          <label>Itens</label><br />
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th scope="col">Produto</th>
                <th scope="col">Quantidade Separada</th>
                <th scope="col">Quantidade Disp. Devolução</th>
                <th scope="col">Quantidade Devolução</th>
                <th scope="col">Armazém Devolução</th>
              </tr>
            </thead>
            <tbody>
              {listReturn && listReturn?.length > 0 && listReturn.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>
                      {index + 1}
                    </td>
                    <td>
                      <div className="formDiv">
                        {viewItemProduct(listProducts, item.id_produto)}
                      </div>
                    </td>
                    <td>
                      {item.qtde_separada}
                    </td>
                    <td>
                      {item.quantity_available_return || item.quantidade_disponivel_retorno}
                    </td>
                    <td>
                      <input type="text" placeholder="Quantidade Devolução" value={item.qtde_devolucao} onChange={(e) => setItemReturn(index, e.target.value, 'qtde_devolucao')} maxLength="15" disabled={!getPermission("OPERACOES - REQUISICAO DEVOLUCAO - CADASTRO")} />
                    </td>
                    <td>
                      {item.warehouse_description || item.sugestao_endereco.armazem}
                    </td>
                  </tr>
                )
              })}
              {listReturn?.length === 0 &&
                <tr>
                  <td colSpan={3}><label className='required'>Nenhum registro encontrado!</label></td>
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div className="formDiv">
          <button type="button" className="buttonSubmit" onClick={submit} disabled={!getPermission("OPERACOES - REQUISICAO DEVOLUCAO - CADASTRO")}>Confirmar</button>
          <button type="button" className="buttonCancel" onClick={() => setModalMakeReturn(false)} disabled={!getPermission("OPERACOES - REQUISICAO DEVOLUCAO - CADASTRO")}>Cancelar</button>
        </div>
      </div>
    </Modal>
  )
}